// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: "http://localhost:8080" | (string & {});
};

/**
 * APIParameter
 */
export type ApiParameter = {
  name: string;
  value: string;
  description?: string | null;
  type: "Header" | "QueryParameter";
};

export const ApiParameterType = {
  HEADER: "Header",
  QUERY_PARAMETER: "QueryParameter",
} as const;

export type ApiParameterType =
  (typeof ApiParameterType)[keyof typeof ApiParameterType];

export const EntityIconToken = {
  BUILDING_BANK: "buildingBank",
  BITCOIN: "bitcoin",
  BUILDINGS: "buildings",
  MAP_PIN: "mapPin",
  SERVER: "server",
  BRIEFCASE: "briefcase",
  WORLD_WWW: "worldWww",
  MAIL: "mail",
  FILE: "file",
  CODE_DOTS: "codeDots",
  RADAR: "radar",
  SERVER_BOLT: "serverBolt",
  AFFILIATE: "affiliate",
  SERVER_COG: "serverCog",
  USERS_GROUP: "usersGroup",
  USER: "user",
  DEVICE_MOBILE: "deviceMobile",
  SHIELD_CHECK: "shieldCheck",
  LINK: "link",
} as const;

export type EntityIconToken =
  (typeof EntityIconToken)[keyof typeof EntityIconToken];

/**
 * QueryAction
 */
export type QueryAction = {
  id: string;
  name: string;
  method: "GET" | "POST" | "PUT" | "DELETE";
  url: string;
  description?: string | null;
  integrationId: string;
  requestPayload?: string | null;
  inputMappings?: Array<InputParameterSpec>;
  outputMappings?: Array<{
    id: string;
    entityId: string;
    relationship: string;
    liquidTemplate: string;
    isRoot?: boolean | null;
    outputType: "STRING" | "LIST";
    qualifiedName: string;
  }>;
  apiParameters?: Array<ApiParameter>;
  defaultAgenticSettings?: {
    id: string;
    confidenceLevel: "low" | "medium" | "high";
    costWeight: number;
    maxRetries: number;
    preconditions: string;
    timeoutSeconds: number;
    createdAt: string;
    updatedAt: string;
  };
  integrationType: "Custom" | "Google" | "LocalTransform";
  integrationName: string;
  baseUrl: string;
};

/**
 * Integration
 */
export type Integration =
  | {
      name: string;
      type: "Custom";
      iconUrl?: string | null;
      baseUrl: string;
      description?: string | null;
      authenticationDetails:
        | {
            authenticationType: "Basic";
            authenticationDetails: {
              userName: string;
              password: string;
            };
          }
        | {
            authenticationType: "APIKey";
            authenticationDetails: {
              apiKey: string;
              apiKeyName: string;
              mappingType: "Header" | "QueryParameter";
            };
          }
        | {
            authenticationType: "None";
          };
      apiParameters?: Array<ApiParameter>;
      integrationDetails: {
        connectionName: string;
      };
      id: string;
      queryActions: Array<{
        id: string;
        name: string;
        method: "GET" | "POST" | "PUT" | "DELETE";
        url: string;
        description?: string | null;
        integrationId: string;
        requestPayload?: string | null;
        inputMappings?: Array<InputParameterSpec>;
        outputMappings?: Array<{
          id: string;
          entityId: string;
          relationship: string;
          liquidTemplate: string;
          isRoot?: boolean | null;
          outputType: "STRING" | "LIST";
          qualifiedName: string;
        }>;
      }>;
    }
  | {
      name: string;
      type: "Google";
      iconUrl?: string | null;
      baseUrl: string;
      description?: string | null;
      authenticationDetails:
        | {
            authenticationType: "Basic";
            authenticationDetails: {
              userName: string;
              password: string;
            };
          }
        | {
            authenticationType: "APIKey";
            authenticationDetails: {
              apiKey: string;
              apiKeyName: string;
              mappingType: "Header" | "QueryParameter";
            };
          }
        | {
            authenticationType: "None";
          };
      apiParameters?: Array<ApiParameter>;
      integrationDetails: {
        clientEmail: string;
        privateKey: string;
        privateKeyId: string;
        delegatedAdminEmail: string;
      };
      id: string;
      queryActions: Array<{
        id: string;
        name: string;
        method: "GET" | "POST" | "PUT" | "DELETE";
        url: string;
        description?: string | null;
        integrationId: string;
        requestPayload?: string | null;
        inputMappings?: Array<InputParameterSpec>;
        outputMappings?: Array<{
          id: string;
          entityId: string;
          relationship: string;
          liquidTemplate: string;
          isRoot?: boolean | null;
          outputType: "STRING" | "LIST";
          qualifiedName: string;
        }>;
      }>;
    }
  | {
      name: string;
      type: "LocalTransform";
      iconUrl?: string | null;
      baseUrl: string;
      description?: string | null;
      authenticationDetails:
        | {
            authenticationType: "Basic";
            authenticationDetails: {
              userName: string;
              password: string;
            };
          }
        | {
            authenticationType: "APIKey";
            authenticationDetails: {
              apiKey: string;
              apiKeyName: string;
              mappingType: "Header" | "QueryParameter";
            };
          }
        | {
            authenticationType: "None";
          };
      apiParameters?: Array<ApiParameter>;
      id: string;
      queryActions: Array<{
        id: string;
        name: string;
        method: "GET" | "POST" | "PUT" | "DELETE";
        url: string;
        description?: string | null;
        integrationId: string;
        requestPayload?: string | null;
        inputMappings?: Array<InputParameterSpec>;
        outputMappings?: Array<{
          id: string;
          entityId: string;
          relationship: string;
          liquidTemplate: string;
          isRoot?: boolean | null;
          outputType: "STRING" | "LIST";
          qualifiedName: string;
        }>;
      }>;
    };

/**
 * InputParameter
 */
export type InputParameter = {
  qualifiedName: string;
  value: string;
};

/**
 * InputParameterSpec
 */
export type InputParameterSpec = {
  entityId?: string;
  qualifiedName: string;
  type: "Entity" | "Runtime";
};

export type Entity = {
  id: string;
  name: string;
  qualifiedName: string;
  icon: string;
  colorSchema:
    | "emerald"
    | "yellow"
    | "teal"
    | "red"
    | "blue"
    | "neutral"
    | "indigo"
    | "sky"
    | "orange"
    | "purple"
    | "violet"
    | "green"
    | "fuchsia"
    | "rose"
    | "cyan"
    | "lime"
    | "amber"
    | "pink";
  defaultValue?: string | null;
  description?: string | null;
  valueRegExpPattern?: string | null;
  isNative: boolean;
  entityClassId: string;
  createdAt: string;
  updatedAt: string;
  connectionsCount?: number;
  className: string;
};

export type EntityClass = {
  id: string;
  name: string;
  iconUrl?: string | null;
  description?: string | null;
  builtIn: boolean;
  isNative: boolean;
  createdAt: string;
  updatedAt: string;
  entities: Array<Entity>;
};

export type EntityClassUpsert = {
  name: string;
  iconUrl?: string | null;
  description?: string | null;
};

export type EntityUpsert = {
  name: string;
  qualifiedName: string;
  icon: string;
  colorSchema:
    | "emerald"
    | "yellow"
    | "teal"
    | "red"
    | "blue"
    | "neutral"
    | "indigo"
    | "sky"
    | "orange"
    | "purple"
    | "violet"
    | "green"
    | "fuchsia"
    | "rose"
    | "cyan"
    | "lime"
    | "amber"
    | "pink";
  defaultValue?: string | null;
  description?: string | null;
  valueRegExpPattern?: string | null;
  entityClassId: string;
};

export type Workflow = {
  id: string;
  status: WorkflowStatus;
  title: string;
  sourceId?: string;
  graphHostId?: string;
  timestamp: Date;
  rawResponse?: string;
  queryActionId?: string;
  relationshipIds: Array<string>;
};

export type PaginatedResponse = {
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
};

export type ValidationError = {
  code?: string;
  message: string;
  errors?: {
    [key: string]: string;
  };
};

export type Error = {
  code?: string;
  message: string;
  details?: string;
};

export type GraphDetails = {
  nodes: Array<GraphNode>;
  edges: Array<GraphEdge>;
  clusters?: Array<GraphCluster>;
  layout?: GraphLayout;
};

export type GraphSummary = {
  id: string;
  name: string;
  format?:
    | "manual"
    | "fcose"
    | "verticaltree"
    | "horizontaltree"
    | "circle"
    | null;
  clustersEnabled?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export const EntityColorSchema = {
  EMERALD: "emerald",
  YELLOW: "yellow",
  TEAL: "teal",
  RED: "red",
  BLUE: "blue",
  NEUTRAL: "neutral",
  INDIGO: "indigo",
  SKY: "sky",
  ORANGE: "orange",
  PURPLE: "purple",
  VIOLET: "violet",
  GREEN: "green",
  FUCHSIA: "fuchsia",
  ROSE: "rose",
  CYAN: "cyan",
  LIME: "lime",
  AMBER: "amber",
  PINK: "pink",
} as const;

export type EntityColorSchema =
  (typeof EntityColorSchema)[keyof typeof EntityColorSchema];

export const IntegrationAuthenticationType = {
  BASIC: "Basic",
  API_KEY: "APIKey",
  NONE: "None",
} as const;

export type IntegrationAuthenticationType =
  (typeof IntegrationAuthenticationType)[keyof typeof IntegrationAuthenticationType];

export const WorkflowStatus = {
  INITIALIZING: "INITIALIZING",
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  SUCCEEDED_PENDING: "SUCCEEDED_PENDING",
  FAILED: "FAILED",
  TIMED_OUT: "TIMED_OUT",
  ABORTED: "ABORTED",
  PENDING_REDRIVE: "PENDING_REDRIVE",
  PENDING: "PENDING",
  QUEUED: "QUEUED",
} as const;

export type WorkflowStatus =
  (typeof WorkflowStatus)[keyof typeof WorkflowStatus];

export type GraphNode = {
  id: string;
  entityId: string;
  value: string;
  workflowIds?: Array<string>;
  position?: {
    x: number;
    y: number;
  };
  flagColor?: string;
  isFlagged?: boolean;
  /**
   * if the nodes belongs to a cluster, the cluster id
   */
  clusterId?: string;
  icon?: string;
  colorSchema?:
    | "emerald"
    | "yellow"
    | "teal"
    | "red"
    | "blue"
    | "neutral"
    | "indigo"
    | "sky"
    | "orange"
    | "purple"
    | "violet"
    | "green"
    | "fuchsia"
    | "rose"
    | "cyan"
    | "lime"
    | "amber"
    | "pink";
  entityName?: string;
  entityQualifiedName?: string;
};

/**
 * Sort workflows by timestamp in ascending or descending order
 */
export const SortDirection = { ASC: "asc", DESC: "desc" } as const;

/**
 * Sort workflows by timestamp in ascending or descending order
 */
export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];

export type User = {
  id: string;
  fullName: string;
  email: string;
  status: "Active" | "Pending" | "Disabled";
};

export type GraphEdge = {
  id: string;
  value: string;
  sourceId: string;
  targetId: string;
  workflowIds?: Array<string>;
};

export type GraphCluster = {
  id: string;
  label: string;
  entityId: string;
  nodeIds: Array<string>;
  icon?: string;
  colorSchema?:
    | "emerald"
    | "yellow"
    | "teal"
    | "red"
    | "blue"
    | "neutral"
    | "indigo"
    | "sky"
    | "orange"
    | "purple"
    | "violet"
    | "green"
    | "fuchsia"
    | "rose"
    | "cyan"
    | "lime"
    | "amber"
    | "pink";
  entityName?: string;
  entityQualifiedName?: string;
};

export type ApiKeyMetadata = {
  id: string;
  description?: string;
  status: "Active" | "Disabled";
  creator: string;
  createdAt: string;
};

export type PageParam = number;

export type PageSizeParam = number;

export type Agent = {
  id: string;
  name: string;
  description: string;
  objective: string;
  url: string;
  successCriteria: string;
  failureCriteria: string;
  returnSchema: string;
  createdAt: string;
  updatedAt: string;
  exampleJson?: string | null;
  toolMappings: Array<{
    queryActionId: string;
    agenticSettings?: {
      confidenceLevel: "low" | "medium" | "high";
      costWeight: number;
      maxRetries: number;
      preconditions: string;
      timeoutSeconds: number;
    };
  }>;
  notificationProviders?: Array<Destination>;
  entityMappings: Array<{
    id: string;
    entityId: string;
    relationship: string;
    liquidTemplate: string;
    isRoot?: boolean | null;
    outputType: "STRING" | "LIST";
    qualifiedName: string;
  }>;
};

export type EventSummary = {
  id: string;
  summary: string;
  assessment: string;
  source: string;
  status: WorkflowStatus;
  createdAt: string;
  updatedAt: string;
  durationSeconds: number;
};

export type EventDetail = EventSummary & {
  ip: string;
  objective: string;
  location: string;
  userAgent: string;
  severity?: string;
  triggerPayload: string;
  resultPayload: string;
  timeline: Array<{
    id: string;
    action: string;
    time: string;
    start: string;
    end: string;
    duration: number;
    status: string;
    description: string;
    summary: string;
    plan: string;
    responsePayload: string;
    toolName?: string;
    inputPayload: string;
  }>;
  /**
   * The ID of the graph associated with the event
   */
  graphId?: string;
  /**
   * The nodes associated with the event graph
   */
  nodes?: Array<{
    id: string;
    value: string;
    entityId: string;
    entityName: string;
    entityQualifiedName: string;
    graphId: string;
  }>;
};

export type CopilotAction = {
  /**
   * A user friendly description of the action for the UI
   */
  description: string;
  params: {
    /**
     * Graph ID
     */
    graphId: string;
    /**
     * Node ID
     */
    nodeId: string;
    /**
     * Query action with runtime values
     */
    queryAction: {
      /**
       * Query Action ID
       */
      id: string;
      /**
       * Query Action input parameters
       */
      inputParameters: Array<InputParameter>;
      /**
       * Selected output mapping IDs (relationship IDs) to execute
       */
      selectedOutputMappingIds: Array<string>;
    };
  };
};

export type GraphCsvUploadMapping = {
  columns: {
    [key: string]:
      | {
          ignore: false;
          entityTypeId: string;
        }
      | {
          ignore: true;
        };
  };
  relationships?: Array<{
    source: {
      column: string;
      entityTypeId: string;
    };
    target: {
      column: string;
      entityTypeId: string;
    };
    type: string;
  }>;
};

export type CopilotMessage = {
  sessionId: string;
  messageId: string;
  role: "user" | "assistant";
  content: string;
  createdAt: string;
  actions?: Array<CopilotAction>;
  isPartial: boolean;
};

/**
 * QueryActionForNode
 *
 * A Query Action as represented in the node graph
 */
export type QueryActionForNode = {
  id: string;
  name: string;
  description: string;
  integrationDescription: string;
  integrationId: string;
  integrationName: string;
  /**
   * Whether this action has already been run for this node
   */
  alreadyRun: boolean;
  /**
   * The date and time this action was last run
   */
  lastRun?: Date;
  /**
   * Relative cost weight of this action compared to others in the same integration
   */
  costWeight?: number;
  /**
   * The input entities for this action
   */
  inputMappings: Array<InputParameterSpec>;
  /**
   * The output entities for this action
   */
  outputMappings: Array<{
    id: string;
    entityId: string;
    alertSourceId?: string | null;
    relationship: string;
    isRoot?: boolean | null;
    outputType: "STRING" | "LIST";
    outputEntityType: string;
    outputEntityQualifiedName: string;
    outputEntityDescription?: string;
    /**
     * Whether this relationship has already been processed for this node
     */
    alreadyRun: boolean;
    /**
     * The date and time this relationship was last run
     */
    lastRun?: Date;
  }>;
};

/**
 * NotificationProvider
 */
export type Destination =
  | {
      name: string;
      description?: string;
      type: "Slack";
      providerDetails: {
        url: string;
        channel: string;
        username?: string;
      };
      id: string;
    }
  | {
      name: string;
      description?: string;
      type: "Email";
      providerDetails: {
        email: string;
        subject: string;
        text: string;
      };
      id: string;
    }
  | {
      name: string;
      description?: string;
      type: "Webhook";
      providerDetails: {
        url: string;
        method: "GET" | "POST" | "PUT" | "DELETE";
      };
      id: string;
    };

/**
 * KnowledgeBase
 */
export type KnowledgeBase = {
  id: string;
  name: string;
  description: string;
  tags: Array<string>;
  createdAt: string;
  updatedAt: string;
  /**
   * KnowledgeBaseFileListResponse
   */
  files: Array<{
    id: string;
    filename: string;
    description: string;
    tags: Array<string>;
    mimeType: string;
    sizeBytes: number;
    uploadedAt: Date;
    workflowId: string | null;
    processingStatus?: WorkflowStatus;
    downloadUrl: string;
  }>;
};

export const GraphLayout = {
  MANUAL: "manual",
  FCOSE: "fcose",
  VERTICALTREE: "verticaltree",
  HORIZONTALTREE: "horizontaltree",
  CIRCLE: "circle",
} as const;

export type GraphLayout = (typeof GraphLayout)[keyof typeof GraphLayout];

/**
 * WorkflowStreamEvent
 *
 * Server-Sent Event payload for workflow stream updates
 */
export type WorkflowStreamEvent =
  | {
      type: "connected";
      graphId: string;
    }
  | {
      type: "workflow:started";
      workflow: Workflow;
    }
  | {
      type: "workflow:success";
      workflow: Workflow;
      /**
       * Nodes and edges that are affected by the workflow
       */
      graphDetails?: GraphDetails;
    }
  | {
      type: "workflow:failed";
      workflow: Workflow;
    }
  | {
      type: "error";
      error: string;
    };

/**
 * SseEvent
 *
 * Server-Sent Event wrapper. The 'data' field contains the JSON-serialized WorkflowStreamEvent.
 */
export type SseEvent = {
  event?:
    | "connected"
    | "workflow:failed"
    | "workflow:started"
    | "workflow:success"
    | "error";
  id?: string;
  retry?: number;
  data: WorkflowStreamEvent;
};

/**
 * CopilotSseEvent
 *
 * Server-Sent Event wrapper. The 'data' field contains the JSON-serialized CopilotStreamingEventDTO.
 */
export type CopilotSseEvent = {
  event?: "chunk" | "action" | "end" | "error";
  id?: string;
  retry?: number;
  data: CopilotStreamingEvent;
};

export type CopilotStreamingEvent =
  | {
      type: "chunk";
      text: string;
    }
  | {
      type: "end";
      answer: string;
      actions?: Array<CopilotAction>;
    }
  | {
      type: "error";
      error: string;
    }
  | {
      type: "action";
      action: CopilotAction;
    };

export type CopilotSession = {
  id: string;
  userId: string;
  createdAt: string;
  type?: "chat" | "graph";
  name?: string;
};

export type CopilotConversation = {
  session: CopilotSession;
  messages: Array<CopilotMessage>;
};

export type Poller = {
  id: string;
  name: string;
  queryActionId: string;
  alertSourceId: string;
  workflowId?: string | null;
  createdAt: string;
  updatedAt: string;
  agentName: string;
  queryActionName: string;
  integrationType: string;
  integrationIconUrl?: string | null;
  workflowStatus?: WorkflowStatus | null;
  inputMappings?: Array<InputParameter>;
  lastRunAt?: string | null;
};

export type GetDocsYmlData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/docs/yml";
};

export type GetDocsYmlResponses = {
  /**
   * Default Response
   */
  200: unknown;
};

export type ListMcpToolsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/mcp/tools";
};

export type ListMcpToolsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListMcpToolsError = ListMcpToolsErrors[keyof ListMcpToolsErrors];

export type ListMcpToolsResponses = {
  /**
   * Default Response
   */
  200: {
    tools: Array<unknown>;
    nextCursor: string | null;
  };
};

export type ListMcpToolsResponse =
  ListMcpToolsResponses[keyof ListMcpToolsResponses];

export type ListMcpToolsJsonRpcData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/mcp/tools.jsonrpc";
};

export type ListMcpToolsJsonRpcErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListMcpToolsJsonRpcError =
  ListMcpToolsJsonRpcErrors[keyof ListMcpToolsJsonRpcErrors];

export type ListMcpToolsJsonRpcResponses = {
  /**
   * Default Response
   */
  200: {
    jsonrpc: string;
    id: number;
    result: {
      tools: Array<unknown>;
      nextCursor: string | null;
    };
  };
};

export type ListMcpToolsJsonRpcResponse =
  ListMcpToolsJsonRpcResponses[keyof ListMcpToolsJsonRpcResponses];

export type ListMcpToolsByWebhookData = {
  body?: never;
  path: {
    webhookId: string;
  };
  query?: never;
  url: "/mcp/tools/{webhookId}";
};

export type ListMcpToolsByWebhookErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListMcpToolsByWebhookError =
  ListMcpToolsByWebhookErrors[keyof ListMcpToolsByWebhookErrors];

export type ListMcpToolsByWebhookResponses = {
  /**
   * Default Response
   */
  200: {
    tools: Array<unknown>;
    nextCursor: string | null;
  };
};

export type ListMcpToolsByWebhookResponse =
  ListMcpToolsByWebhookResponses[keyof ListMcpToolsByWebhookResponses];

export type HydrateToolData = {
  /**
   * HydrateToolRequest
   *
   * Key-value pairs where keys are the tool parameter names (qualifiedName) and values are the parameter values
   */
  body?: {
    [key: string]: string;
  };
  path: {
    /**
     * The ID of the tool to hydrate
     */
    toolId: string;
  };
  query?: never;
  url: "/mcp/tools/{toolId}/hydrate";
};

export type HydrateToolErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type HydrateToolError = HydrateToolErrors[keyof HydrateToolErrors];

export type HydrateToolResponses = {
  /**
   * Default Response
   */
  200: unknown;
};

export type ListAgentsData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/agents";
};

export type ListAgentsResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<Agent>;
  };
};

export type ListAgentsResponse = ListAgentsResponses[keyof ListAgentsResponses];

export type CreateAgentData = {
  body: {
    name: string;
    description: string;
    objective: string;
    successCriteria: string;
    failureCriteria: string;
    returnSchema: string;
    exampleJson?: string | null;
    toolMappings: Array<{
      queryActionId: string;
      agenticSettings?: {
        confidenceLevel: "low" | "medium" | "high";
        costWeight: number;
        maxRetries: number;
        preconditions: string;
        timeoutSeconds: number;
      };
    }>;
    entityMappings?: Array<{
      qualifiedName: string;
      relationship: string;
      liquidTemplate: string;
      outputType: "STRING" | "LIST";
      isRoot?: boolean | null;
    }>;
    notificationProviders?: Array<{
      providerId: string;
    }>;
  };
  path?: never;
  query?: never;
  url: "/agents";
};

export type CreateAgentErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateAgentError = CreateAgentErrors[keyof CreateAgentErrors];

export type CreateAgentResponses = {
  /**
   * Default Response
   */
  201: Agent;
};

export type CreateAgentResponse =
  CreateAgentResponses[keyof CreateAgentResponses];

export type DeleteAgentData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/agents/{id}";
};

export type DeleteAgentErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteAgentError = DeleteAgentErrors[keyof DeleteAgentErrors];

export type DeleteAgentResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteAgentResponse =
  DeleteAgentResponses[keyof DeleteAgentResponses];

export type GetAgentData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/agents/{id}";
};

export type GetAgentErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetAgentError = GetAgentErrors[keyof GetAgentErrors];

export type GetAgentResponses = {
  /**
   * Default Response
   */
  200: Agent;
};

export type GetAgentResponse = GetAgentResponses[keyof GetAgentResponses];

export type UpdateAgentData = {
  body?: {
    name?: string;
    description?: string;
    objective?: string;
    successCriteria?: string;
    failureCriteria?: string;
    returnSchema?: string;
    exampleJson?: string | null;
    toolMappings?: Array<{
      queryActionId: string;
      agenticSettings?: {
        confidenceLevel: "low" | "medium" | "high";
        costWeight: number;
        maxRetries: number;
        preconditions: string;
        timeoutSeconds: number;
      };
    }>;
    entityMappings?: Array<{
      qualifiedName: string;
      relationship: string;
      liquidTemplate: string;
      outputType: "STRING" | "LIST";
      isRoot?: boolean | null;
    }>;
    notificationProviders?: Array<{
      providerId: string;
    }>;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/agents/{id}";
};

export type UpdateAgentErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateAgentError = UpdateAgentErrors[keyof UpdateAgentErrors];

export type UpdateAgentResponses = {
  /**
   * Default Response
   */
  200: Agent;
};

export type UpdateAgentResponse =
  UpdateAgentResponses[keyof UpdateAgentResponses];

export type SearchAgentsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Search term to match against alert source name
     */
    searchTerm: string;
  };
  url: "/agents/search";
};

export type SearchAgentsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SearchAgentsError = SearchAgentsErrors[keyof SearchAgentsErrors];

export type SearchAgentsResponses = {
  /**
   * Default Response
   */
  200: Array<Agent>;
};

export type SearchAgentsResponse =
  SearchAgentsResponses[keyof SearchAgentsResponses];

export type CreateEntityData = {
  body?: EntityUpsert;
  path?: never;
  query?: never;
  url: "/entities";
};

export type CreateEntityErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateEntityError = CreateEntityErrors[keyof CreateEntityErrors];

export type CreateEntityResponses = {
  /**
   * Default Response
   */
  201: Entity;
};

export type CreateEntityResponse =
  CreateEntityResponses[keyof CreateEntityResponses];

export type DeleteEntityData = {
  body?: never;
  path: {
    entityId: string;
  };
  query?: never;
  url: "/entities/{entityId}";
};

export type DeleteEntityErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteEntityError = DeleteEntityErrors[keyof DeleteEntityErrors];

export type DeleteEntityResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteEntityResponse =
  DeleteEntityResponses[keyof DeleteEntityResponses];

export type GetEntityData = {
  body?: never;
  path: {
    entityId: string;
  };
  query?: never;
  url: "/entities/{entityId}";
};

export type GetEntityErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetEntityError = GetEntityErrors[keyof GetEntityErrors];

export type GetEntityResponses = {
  /**
   * Default Response
   */
  200: Entity;
};

export type GetEntityResponse = GetEntityResponses[keyof GetEntityResponses];

export type UpdateEntityData = {
  body?: {
    name?: string;
    qualifiedName?: string;
    icon?: string;
    colorSchema?:
      | "emerald"
      | "yellow"
      | "teal"
      | "red"
      | "blue"
      | "neutral"
      | "indigo"
      | "sky"
      | "orange"
      | "purple"
      | "violet"
      | "green"
      | "fuchsia"
      | "rose"
      | "cyan"
      | "lime"
      | "amber"
      | "pink";
    defaultValue?: string | null;
    description?: string | null;
    valueRegExpPattern?: string | null;
    entityClassId?: string;
  };
  path: {
    entityId: string;
  };
  query?: never;
  url: "/entities/{entityId}";
};

export type UpdateEntityErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateEntityError = UpdateEntityErrors[keyof UpdateEntityErrors];

export type UpdateEntityResponses = {
  /**
   * Default Response
   */
  200: Entity;
};

export type UpdateEntityResponse =
  UpdateEntityResponses[keyof UpdateEntityResponses];

export type GetEntityByQualifiedNameData = {
  body?: never;
  path: {
    qualifiedName: string;
  };
  query?: never;
  url: "/entities/by-qualified-name/{qualifiedName}";
};

export type GetEntityByQualifiedNameErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetEntityByQualifiedNameError =
  GetEntityByQualifiedNameErrors[keyof GetEntityByQualifiedNameErrors];

export type GetEntityByQualifiedNameResponses = {
  /**
   * Default Response
   */
  200: Entity;
};

export type GetEntityByQualifiedNameResponse =
  GetEntityByQualifiedNameResponses[keyof GetEntityByQualifiedNameResponses];

export type ListTopEntitiesData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Maximum number of entities to return
     */
    limit?: number;
  };
  url: "/entities/top";
};

export type ListTopEntitiesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListTopEntitiesError =
  ListTopEntitiesErrors[keyof ListTopEntitiesErrors];

export type ListTopEntitiesResponses = {
  /**
   * Default Response
   */
  200: Array<Entity>;
};

export type ListTopEntitiesResponse =
  ListTopEntitiesResponses[keyof ListTopEntitiesResponses];

export type ListEntitiesShortnamesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/entities-shortlist";
};

export type ListEntitiesShortnamesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListEntitiesShortnamesError =
  ListEntitiesShortnamesErrors[keyof ListEntitiesShortnamesErrors];

export type ListEntitiesShortnamesResponses = {
  /**
   * Default Response
   */
  200: Array<string>;
};

export type ListEntitiesShortnamesResponse =
  ListEntitiesShortnamesResponses[keyof ListEntitiesShortnamesResponses];

export type SearchEntitiesData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Search term to match against name, qualifiedName, and description
     */
    searchTerm: string;
  };
  url: "/entities/search";
};

export type SearchEntitiesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SearchEntitiesError =
  SearchEntitiesErrors[keyof SearchEntitiesErrors];

export type SearchEntitiesResponses = {
  /**
   * Default Response
   */
  200: Array<Entity>;
};

export type SearchEntitiesResponse =
  SearchEntitiesResponses[keyof SearchEntitiesResponses];

export type CopilotQueryStreamData = {
  body: {
    sessionId: string;
    message: string;
    context?: {
      currentRoute?: string;
      userId?: string;
      graphId?: string;
      selectedNodes?: Array<string>;
      groupedNodes?: Array<{
        groupName: string;
        nodeIds: Array<string>;
      }>;
    };
  };
  path?: never;
  query?: never;
  url: "/copilot/query";
};

export type CopilotQueryStreamErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * SSE payload: event: error, data: message
   */
  406: string;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CopilotQueryStreamError =
  CopilotQueryStreamErrors[keyof CopilotQueryStreamErrors];

export type CopilotQueryStreamResponses = {
  /**
   * Server-Sent Events stream
   */
  200: CopilotSseEvent;
};

export type CopilotQueryStreamResponse =
  CopilotQueryStreamResponses[keyof CopilotQueryStreamResponses];

export type CreateConversationData = {
  body?: never;
  path?: never;
  query?: {
    sessionId?: string;
    type?: "chat" | "graph";
  };
  url: "/copilot/create-conversation";
};

export type CreateConversationErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateConversationError =
  CreateConversationErrors[keyof CreateConversationErrors];

export type CreateConversationResponses = {
  /**
   * Default Response
   */
  200: CopilotSession;
};

export type CreateConversationResponse =
  CreateConversationResponses[keyof CreateConversationResponses];

export type GetConversationData = {
  body: {
    sessionId: string;
  };
  path?: never;
  query?: never;
  url: "/copilot/get-conversation";
};

export type GetConversationErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetConversationError =
  GetConversationErrors[keyof GetConversationErrors];

export type GetConversationResponses = {
  /**
   * Default Response
   */
  200: CopilotConversation;
};

export type GetConversationResponse =
  GetConversationResponses[keyof GetConversationResponses];

export type GetSessionListData = {
  body?: never;
  path?: never;
  query?: {
    type?: "chat" | "graph";
  };
  url: "/copilot/get-sessions";
};

export type GetSessionListErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetSessionListError =
  GetSessionListErrors[keyof GetSessionListErrors];

export type GetSessionListResponses = {
  /**
   * Default Response
   */
  200: Array<CopilotSession>;
};

export type GetSessionListResponse =
  GetSessionListResponses[keyof GetSessionListResponses];

export type GenerateLiquidTemplateData = {
  body: {
    userDescription: string;
    jsonContext: string;
  };
  path?: never;
  query?: never;
  url: "/copilot/generate-liquid-template";
};

export type GenerateLiquidTemplateErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GenerateLiquidTemplateError =
  GenerateLiquidTemplateErrors[keyof GenerateLiquidTemplateErrors];

export type GenerateLiquidTemplateResponses = {
  /**
   * Default Response
   */
  200: {
    template: string;
    noMatch?: boolean;
    message?: string;
  };
};

export type GenerateLiquidTemplateResponse =
  GenerateLiquidTemplateResponses[keyof GenerateLiquidTemplateResponses];

export type GetEventData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/events/{id}";
};

export type GetEventErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetEventError = GetEventErrors[keyof GetEventErrors];

export type GetEventResponses = {
  /**
   * Default Response
   */
  200: EventDetail;
};

export type GetEventResponse = GetEventResponses[keyof GetEventResponses];

export type ListEventsData = {
  body?: never;
  path?: never;
  query?: {
    cursor?: string;
    pageSize?: PageSizeParam;
  };
  url: "/events";
};

export type ListEventsResponses = {
  /**
   * Default Response
   */
  200: {
    nextCursor: string | null;
    hasMore: boolean;
    items: Array<EventSummary>;
  };
};

export type ListEventsResponse = ListEventsResponses[keyof ListEventsResponses];

export type CancelWorkflowData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/events/{id}/cancel";
};

export type CancelWorkflowErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CancelWorkflowError =
  CancelWorkflowErrors[keyof CancelWorkflowErrors];

export type CancelWorkflowResponses = {
  /**
   * Default Response
   */
  200: {
    /**
     * ID of the created workflow
     */
    id: string;
  };
};

export type CancelWorkflowResponse =
  CancelWorkflowResponses[keyof CancelWorkflowResponses];

export type SearchEventsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Generic search term
     */
    searchTerm: string;
  };
  url: "/events/search";
};

export type SearchEventsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SearchEventsError = SearchEventsErrors[keyof SearchEventsErrors];

export type SearchEventsResponses = {
  /**
   * Default Response
   */
  200: Array<EventSummary>;
};

export type SearchEventsResponse =
  SearchEventsResponses[keyof SearchEventsResponses];

export type ListEntityClassesData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/entity-classes";
};

export type ListEntityClassesResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<EntityClass>;
  };
};

export type ListEntityClassesResponse =
  ListEntityClassesResponses[keyof ListEntityClassesResponses];

export type CreateEntityClassData = {
  body?: EntityClassUpsert;
  path?: never;
  query?: never;
  url: "/entity-classes";
};

export type CreateEntityClassErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateEntityClassError =
  CreateEntityClassErrors[keyof CreateEntityClassErrors];

export type CreateEntityClassResponses = {
  /**
   * Default Response
   */
  201: {
    id: string;
    name: string;
    iconUrl?: string | null;
    description?: string | null;
    builtIn: boolean;
    isNative: boolean;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateEntityClassResponse =
  CreateEntityClassResponses[keyof CreateEntityClassResponses];

export type DeleteEntityClassData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/entity-classes/{id}";
};

export type DeleteEntityClassErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteEntityClassError =
  DeleteEntityClassErrors[keyof DeleteEntityClassErrors];

export type DeleteEntityClassResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteEntityClassResponse =
  DeleteEntityClassResponses[keyof DeleteEntityClassResponses];

export type GetEntityClassData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/entity-classes/{id}";
};

export type GetEntityClassErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetEntityClassError =
  GetEntityClassErrors[keyof GetEntityClassErrors];

export type GetEntityClassResponses = {
  /**
   * Default Response
   */
  200: EntityClass;
};

export type GetEntityClassResponse =
  GetEntityClassResponses[keyof GetEntityClassResponses];

export type UpdateEntityClassData = {
  body?: {
    name?: string;
    iconUrl?: string | null;
    description?: string | null;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/entity-classes/{id}";
};

export type UpdateEntityClassErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateEntityClassError =
  UpdateEntityClassErrors[keyof UpdateEntityClassErrors];

export type UpdateEntityClassResponses = {
  /**
   * Default Response
   */
  200: {
    id: string;
    name: string;
    iconUrl?: string | null;
    description?: string | null;
    builtIn: boolean;
    isNative: boolean;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateEntityClassResponse =
  UpdateEntityClassResponses[keyof UpdateEntityClassResponses];

export type ListKnowledgeBasesData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/knowledge-bases";
};

export type ListKnowledgeBasesResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<KnowledgeBase>;
  };
};

export type ListKnowledgeBasesResponse =
  ListKnowledgeBasesResponses[keyof ListKnowledgeBasesResponses];

export type CreateKnowledgeBaseData = {
  /**
   * Create Knowledge Base
   */
  body: {
    name: string;
    description: string;
    tags?: Array<string>;
  };
  path?: never;
  query?: never;
  url: "/knowledge-bases";
};

export type CreateKnowledgeBaseErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateKnowledgeBaseError =
  CreateKnowledgeBaseErrors[keyof CreateKnowledgeBaseErrors];

export type CreateKnowledgeBaseResponses = {
  /**
   * KnowledgeBaseCreateResponse
   *
   * Default Response
   */
  201: KnowledgeBase;
};

export type CreateKnowledgeBaseResponse =
  CreateKnowledgeBaseResponses[keyof CreateKnowledgeBaseResponses];

export type DeleteKnowledgeBaseData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/knowledge-bases/{id}";
};

export type DeleteKnowledgeBaseErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteKnowledgeBaseError =
  DeleteKnowledgeBaseErrors[keyof DeleteKnowledgeBaseErrors];

export type DeleteKnowledgeBaseResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteKnowledgeBaseResponse =
  DeleteKnowledgeBaseResponses[keyof DeleteKnowledgeBaseResponses];

export type GetKnowledgeBaseData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/knowledge-bases/{id}";
};

export type GetKnowledgeBaseErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetKnowledgeBaseError =
  GetKnowledgeBaseErrors[keyof GetKnowledgeBaseErrors];

export type GetKnowledgeBaseResponses = {
  /**
   * Default Response
   */
  200: KnowledgeBase;
};

export type GetKnowledgeBaseResponse =
  GetKnowledgeBaseResponses[keyof GetKnowledgeBaseResponses];

export type UpdateKnowledgeBaseData = {
  /**
   * Update Knowledge Base
   */
  body?: {
    name?: string;
    description?: string;
    tags?: Array<string>;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/knowledge-bases/{id}";
};

export type UpdateKnowledgeBaseErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateKnowledgeBaseError =
  UpdateKnowledgeBaseErrors[keyof UpdateKnowledgeBaseErrors];

export type UpdateKnowledgeBaseResponses = {
  /**
   * KnowledgeBaseUpdateResponse
   *
   * Default Response
   */
  200: KnowledgeBase;
};

export type UpdateKnowledgeBaseResponse =
  UpdateKnowledgeBaseResponses[keyof UpdateKnowledgeBaseResponses];

export type ListKnowledgeBaseFilesData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/knowledge-bases/{id}/files";
};

export type ListKnowledgeBaseFilesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListKnowledgeBaseFilesError =
  ListKnowledgeBaseFilesErrors[keyof ListKnowledgeBaseFilesErrors];

export type ListKnowledgeBaseFilesResponses = {
  /**
   * KnowledgeBaseFileListResponse
   *
   * Default Response
   */
  200: Array<{
    id: string;
    filename: string;
    description: string;
    tags: Array<string>;
    mimeType: string;
    sizeBytes: number;
    uploadedAt: Date;
    workflowId: string | null;
    processingStatus?: WorkflowStatus;
    downloadUrl: string;
  }>;
};

export type ListKnowledgeBaseFilesResponse =
  ListKnowledgeBaseFilesResponses[keyof ListKnowledgeBaseFilesResponses];

export type PostKnowledgeBasesByIdFilesData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/knowledge-bases/{id}/files";
};

export type PostKnowledgeBasesByIdFilesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type PostKnowledgeBasesByIdFilesError =
  PostKnowledgeBasesByIdFilesErrors[keyof PostKnowledgeBasesByIdFilesErrors];

export type PostKnowledgeBasesByIdFilesResponses = {
  /**
   * KnowledgeBaseFileUploadResponse
   *
   * Default Response
   */
  201: {
    /**
     * Unique file identifier
     */
    fileId: string;
    /**
     * Myqro workflow ID for tracking processing
     */
    workflowId: string;
  };
};

export type PostKnowledgeBasesByIdFilesResponse =
  PostKnowledgeBasesByIdFilesResponses[keyof PostKnowledgeBasesByIdFilesResponses];

export type DeleteKnowledgeBaseFileData = {
  body?: never;
  path: {
    id: string;
    fileId: string;
  };
  query?: never;
  url: "/knowledge-bases/{id}/files/{fileId}";
};

export type DeleteKnowledgeBaseFileErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteKnowledgeBaseFileError =
  DeleteKnowledgeBaseFileErrors[keyof DeleteKnowledgeBaseFileErrors];

export type DeleteKnowledgeBaseFileResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteKnowledgeBaseFileResponse =
  DeleteKnowledgeBaseFileResponses[keyof DeleteKnowledgeBaseFileResponses];

export type ListApiKeysData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/api-keys";
};

export type ListApiKeysResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<ApiKeyMetadata>;
  };
};

export type ListApiKeysResponse =
  ListApiKeysResponses[keyof ListApiKeysResponses];

export type CreateApiKeyData = {
  body?: {
    description?: string;
  };
  path?: never;
  query?: never;
  url: "/api-keys";
};

export type CreateApiKeyErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateApiKeyError = CreateApiKeyErrors[keyof CreateApiKeyErrors];

export type CreateApiKeyResponses = {
  /**
   * Default Response
   */
  201: ApiKeyMetadata & {
    key: string;
  };
};

export type CreateApiKeyResponse =
  CreateApiKeyResponses[keyof CreateApiKeyResponses];

export type DeleteApiKeyData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/api-keys/{id}";
};

export type DeleteApiKeyErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteApiKeyError = DeleteApiKeyErrors[keyof DeleteApiKeyErrors];

export type DeleteApiKeyResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteApiKeyResponse =
  DeleteApiKeyResponses[keyof DeleteApiKeyResponses];

export type UpdateApiKeyData = {
  body?: {
    description?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/api-keys/{id}";
};

export type UpdateApiKeyErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateApiKeyError = UpdateApiKeyErrors[keyof UpdateApiKeyErrors];

export type UpdateApiKeyResponses = {
  /**
   * Default Response
   */
  200: ApiKeyMetadata;
};

export type UpdateApiKeyResponse =
  UpdateApiKeyResponses[keyof UpdateApiKeyResponses];

export type ListNotificationProvidersData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/notifications";
};

export type ListNotificationProvidersErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListNotificationProvidersError =
  ListNotificationProvidersErrors[keyof ListNotificationProvidersErrors];

export type ListNotificationProvidersResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<Destination>;
  };
};

export type ListNotificationProvidersResponse =
  ListNotificationProvidersResponses[keyof ListNotificationProvidersResponses];

export type CreateNotificationProviderData = {
  /**
   * Create Notification
   */
  body?:
    | {
        name: string;
        description?: string;
        type: "Slack";
        providerDetails: {
          url: string;
          channel: string;
          username?: string;
        };
      }
    | {
        name: string;
        description?: string;
        type: "Email";
        providerDetails: {
          email: string;
          subject: string;
          text: string;
        };
      }
    | {
        name: string;
        description?: string;
        type: "Webhook";
        providerDetails: {
          url: string;
          method: "GET" | "POST" | "PUT" | "DELETE";
        };
      };
  path?: never;
  query?: never;
  url: "/notifications";
};

export type CreateNotificationProviderErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateNotificationProviderError =
  CreateNotificationProviderErrors[keyof CreateNotificationProviderErrors];

export type CreateNotificationProviderResponses = {
  /**
   * NotificationProviderCreateResponse
   *
   * Default Response
   */
  201: Destination;
};

export type CreateNotificationProviderResponse =
  CreateNotificationProviderResponses[keyof CreateNotificationProviderResponses];

export type DeleteNotificationProviderData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/notifications/{id}";
};

export type DeleteNotificationProviderErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteNotificationProviderError =
  DeleteNotificationProviderErrors[keyof DeleteNotificationProviderErrors];

export type DeleteNotificationProviderResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteNotificationProviderResponse =
  DeleteNotificationProviderResponses[keyof DeleteNotificationProviderResponses];

export type GetNotificationProviderData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/notifications/{id}";
};

export type GetNotificationProviderErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetNotificationProviderError =
  GetNotificationProviderErrors[keyof GetNotificationProviderErrors];

export type GetNotificationProviderResponses = {
  /**
   * Default Response
   */
  200: Destination;
};

export type GetNotificationProviderResponse =
  GetNotificationProviderResponses[keyof GetNotificationProviderResponses];

export type UpdateNotificationProviderData = {
  /**
   * Create Notification
   */
  body?:
    | {
        name: string;
        description?: string;
        type: "Slack";
        providerDetails: {
          url: string;
          channel: string;
          username?: string;
        };
      }
    | {
        name: string;
        description?: string;
        type: "Email";
        providerDetails: {
          email: string;
          subject: string;
          text: string;
        };
      }
    | {
        name: string;
        description?: string;
        type: "Webhook";
        providerDetails: {
          url: string;
          method: "GET" | "POST" | "PUT" | "DELETE";
        };
      };
  path: {
    id: string;
  };
  query?: never;
  url: "/notifications/{id}";
};

export type UpdateNotificationProviderErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateNotificationProviderError =
  UpdateNotificationProviderErrors[keyof UpdateNotificationProviderErrors];

export type UpdateNotificationProviderResponses = {
  /**
   * UpdateNotificationProvidersResponse
   *
   * Default Response
   */
  200: Destination;
};

export type UpdateNotificationProviderResponse =
  UpdateNotificationProviderResponses[keyof UpdateNotificationProviderResponses];

export type SearchNotificationProvidersData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Search term to match against notification provider name or description
     */
    searchTerm: string;
  };
  url: "/notifications/search";
};

export type SearchNotificationProvidersErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SearchNotificationProvidersError =
  SearchNotificationProvidersErrors[keyof SearchNotificationProvidersErrors];

export type SearchNotificationProvidersResponses = {
  /**
   * ListNotificationProvidersResponse
   *
   * Default Response
   */
  200: Array<Destination>;
};

export type SearchNotificationProvidersResponse =
  SearchNotificationProvidersResponses[keyof SearchNotificationProvidersResponses];

export type ListGraphsData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/workspaces";
};

export type ListGraphsResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<GraphSummary>;
  };
};

export type ListGraphsResponse = ListGraphsResponses[keyof ListGraphsResponses];

export type CreateGraphData = {
  body: {
    name: string;
    format?: GraphLayout;
    clustersEnabled?: boolean;
  };
  path?: never;
  query?: never;
  url: "/workspaces";
};

export type CreateGraphErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateGraphError = CreateGraphErrors[keyof CreateGraphErrors];

export type CreateGraphResponses = {
  /**
   * Default Response
   */
  201: GraphSummary;
};

export type CreateGraphResponse =
  CreateGraphResponses[keyof CreateGraphResponses];

export type DeleteGraphData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}";
};

export type DeleteGraphErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteGraphError = DeleteGraphErrors[keyof DeleteGraphErrors];

export type DeleteGraphResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteGraphResponse =
  DeleteGraphResponses[keyof DeleteGraphResponses];

export type CopyGraphData = {
  body: {
    name: string;
    format?: GraphLayout;
    clustersEnabled?: boolean;
    nodeIds?: Array<string>;
    edgeIds?: Array<string>;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/copy";
};

export type CopyGraphErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CopyGraphError = CopyGraphErrors[keyof CopyGraphErrors];

export type CopyGraphResponses = {
  /**
   * Default Response
   */
  201: GraphSummary;
};

export type CopyGraphResponse = CopyGraphResponses[keyof CopyGraphResponses];

export type GetGraphData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/summary";
};

export type GetGraphErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetGraphError = GetGraphErrors[keyof GetGraphErrors];

export type GetGraphResponses = {
  /**
   * Default Response
   */
  200: GraphSummary;
};

export type GetGraphResponse = GetGraphResponses[keyof GetGraphResponses];

export type UpdateGraphData = {
  body?: {
    name?: string;
    format?: GraphLayout;
    clustersEnabled?: boolean;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/summary";
};

export type UpdateGraphErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateGraphError = UpdateGraphErrors[keyof UpdateGraphErrors];

export type UpdateGraphResponses = {
  /**
   * Default Response
   */
  200: GraphSummary;
};

export type UpdateGraphResponse =
  UpdateGraphResponses[keyof UpdateGraphResponses];

export type SearchGraphsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Search term to match against graph name
     */
    searchTerm: string;
  };
  url: "/workspaces/search";
};

export type SearchGraphsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SearchGraphsError = SearchGraphsErrors[keyof SearchGraphsErrors];

export type SearchGraphsResponses = {
  /**
   * Default Response
   */
  200: Array<GraphSummary>;
};

export type SearchGraphsResponse =
  SearchGraphsResponses[keyof SearchGraphsResponses];

export type GetGraphDetailsData = {
  body?: never;
  path: {
    id: string;
  };
  query?: {
    workflowIds?: string | Array<string>;
  };
  url: "/workspaces/{id}/details";
};

export type GetGraphDetailsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetGraphDetailsError =
  GetGraphDetailsErrors[keyof GetGraphDetailsErrors];

export type GetGraphDetailsResponses = {
  /**
   * Default Response
   */
  200: GraphDetails;
};

export type GetGraphDetailsResponse =
  GetGraphDetailsResponses[keyof GetGraphDetailsResponses];

export type AddEdgesData = {
  body?: Array<GraphEdge>;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/edges";
};

export type AddEdgesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type AddEdgesError = AddEdgesErrors[keyof AddEdgesErrors];

export type AddEdgesResponses = {
  /**
   * Default Response
   */
  200: Array<GraphEdge>;
};

export type AddEdgesResponse = AddEdgesResponses[keyof AddEdgesResponses];

export type UpdateEdgesData = {
  body?: Array<{
    id: string;
    value?: string;
    sourceId?: string;
    targetId?: string;
    workflowIds?: Array<string>;
  }>;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/edges";
};

export type UpdateEdgesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateEdgesError = UpdateEdgesErrors[keyof UpdateEdgesErrors];

export type UpdateEdgesResponses = {
  /**
   * Default Response
   */
  200: Array<GraphEdge>;
};

export type UpdateEdgesResponse =
  UpdateEdgesResponses[keyof UpdateEdgesResponses];

export type DeleteElementsData = {
  body?: Array<{
    id: string;
    type: "node" | "edge";
  }>;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/elements";
};

export type DeleteElementsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteElementsError =
  DeleteElementsErrors[keyof DeleteElementsErrors];

export type DeleteElementsResponses = {
  /**
   * Default Response
   */
  200: {
    deleted_nodes?: number;
    deleted_edges?: number;
  };
};

export type DeleteElementsResponse =
  DeleteElementsResponses[keyof DeleteElementsResponses];

export type AddNodesData = {
  body?: Array<GraphNode>;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/nodes";
};

export type AddNodesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type AddNodesError = AddNodesErrors[keyof AddNodesErrors];

export type AddNodesResponses = {
  /**
   * Default Response
   */
  200: Array<GraphNode>;
};

export type AddNodesResponse = AddNodesResponses[keyof AddNodesResponses];

export type UpdateNodesData = {
  body?: Array<{
    id: string;
    entityId?: string;
    value?: string;
    workflowIds?: Array<string>;
    position?: {
      x: number;
      y: number;
    };
    flagColor?: string;
    isFlagged?: boolean;
    /**
     * if the nodes belongs to a cluster, the cluster id
     */
    clusterId?: string;
    icon?: string;
    colorSchema?:
      | "emerald"
      | "yellow"
      | "teal"
      | "red"
      | "blue"
      | "neutral"
      | "indigo"
      | "sky"
      | "orange"
      | "purple"
      | "violet"
      | "green"
      | "fuchsia"
      | "rose"
      | "cyan"
      | "lime"
      | "amber"
      | "pink";
    entityName?: string;
    entityQualifiedName?: string;
  }>;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/nodes";
};

export type UpdateNodesErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateNodesError = UpdateNodesErrors[keyof UpdateNodesErrors];

export type UpdateNodesResponses = {
  /**
   * Default Response
   */
  200: Array<GraphNode>;
};

export type UpdateNodesResponse =
  UpdateNodesResponses[keyof UpdateNodesResponses];

export type UpdateNodePositionsData = {
  body: {
    positions: Array<{
      id: string;
      position: {
        x: number;
        y: number;
      };
    }>;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/node-positions";
};

export type UpdateNodePositionsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateNodePositionsError =
  UpdateNodePositionsErrors[keyof UpdateNodePositionsErrors];

export type UpdateNodePositionsResponses = {
  /**
   * Default Response
   */
  200: Array<GraphNode>;
};

export type UpdateNodePositionsResponse =
  UpdateNodePositionsResponses[keyof UpdateNodePositionsResponses];

export type PostWorkspacesByIdUploadData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/workspaces/{id}/upload";
};

export type PostWorkspacesByIdUploadErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type PostWorkspacesByIdUploadError =
  PostWorkspacesByIdUploadErrors[keyof PostWorkspacesByIdUploadErrors];

export type PostWorkspacesByIdUploadResponses = {
  /**
   * Default Response
   */
  202: {
    jobId: string;
  };
};

export type PostWorkspacesByIdUploadResponse =
  PostWorkspacesByIdUploadResponses[keyof PostWorkspacesByIdUploadResponses];

export type ListIntegrationsData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/integrations";
};

export type ListIntegrationsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListIntegrationsError =
  ListIntegrationsErrors[keyof ListIntegrationsErrors];

export type ListIntegrationsResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<Integration>;
  };
};

export type ListIntegrationsResponse =
  ListIntegrationsResponses[keyof ListIntegrationsResponses];

export type CreateIntegrationData = {
  /**
   * Create Integration
   */
  body?:
    | {
        name: string;
        type: "Custom";
        iconUrl?: string | null;
        baseUrl: string;
        description?: string | null;
        authenticationDetails:
          | {
              authenticationType: "Basic";
              authenticationDetails: {
                userName: string;
                password: string;
              };
            }
          | {
              authenticationType: "APIKey";
              authenticationDetails: {
                apiKey: string;
                apiKeyName: string;
                mappingType: "Header" | "QueryParameter";
              };
            }
          | {
              authenticationType: "None";
            };
        apiParameters?: Array<ApiParameter>;
        integrationDetails: {
          connectionName: string;
        };
      }
    | {
        name: string;
        type: "Google";
        iconUrl?: string | null;
        baseUrl: string;
        description?: string | null;
        authenticationDetails:
          | {
              authenticationType: "Basic";
              authenticationDetails: {
                userName: string;
                password: string;
              };
            }
          | {
              authenticationType: "APIKey";
              authenticationDetails: {
                apiKey: string;
                apiKeyName: string;
                mappingType: "Header" | "QueryParameter";
              };
            }
          | {
              authenticationType: "None";
            };
        apiParameters?: Array<ApiParameter>;
        integrationDetails: {
          clientEmail: string;
          privateKey: string;
          privateKeyId: string;
          delegatedAdminEmail: string;
        };
      }
    | {
        name: string;
        type: "LocalTransform";
        iconUrl?: string | null;
        baseUrl: string;
        description?: string | null;
        authenticationDetails:
          | {
              authenticationType: "Basic";
              authenticationDetails: {
                userName: string;
                password: string;
              };
            }
          | {
              authenticationType: "APIKey";
              authenticationDetails: {
                apiKey: string;
                apiKeyName: string;
                mappingType: "Header" | "QueryParameter";
              };
            }
          | {
              authenticationType: "None";
            };
        apiParameters?: Array<ApiParameter>;
      };
  path?: never;
  query?: never;
  url: "/integrations";
};

export type CreateIntegrationErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateIntegrationError =
  CreateIntegrationErrors[keyof CreateIntegrationErrors];

export type CreateIntegrationResponses = {
  /**
   * IntegrationCreateResponse
   *
   * Default Response
   */
  201: Integration;
};

export type CreateIntegrationResponse =
  CreateIntegrationResponses[keyof CreateIntegrationResponses];

export type DeleteIntegrationData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/integrations/{id}";
};

export type DeleteIntegrationErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteIntegrationError =
  DeleteIntegrationErrors[keyof DeleteIntegrationErrors];

export type DeleteIntegrationResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteIntegrationResponse =
  DeleteIntegrationResponses[keyof DeleteIntegrationResponses];

export type GetIntegrationData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/integrations/{id}";
};

export type GetIntegrationErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetIntegrationError =
  GetIntegrationErrors[keyof GetIntegrationErrors];

export type GetIntegrationResponses = {
  /**
   * Default Response
   */
  200: Integration;
};

export type GetIntegrationResponse =
  GetIntegrationResponses[keyof GetIntegrationResponses];

export type UpdateIntegrationData = {
  /**
   * Create Integration
   */
  body?:
    | {
        name: string;
        type: "Custom";
        iconUrl?: string | null;
        baseUrl: string;
        description?: string | null;
        authenticationDetails:
          | {
              authenticationType: "Basic";
              authenticationDetails: {
                userName: string;
                password: string;
              };
            }
          | {
              authenticationType: "APIKey";
              authenticationDetails: {
                apiKey: string;
                apiKeyName: string;
                mappingType: "Header" | "QueryParameter";
              };
            }
          | {
              authenticationType: "None";
            };
        apiParameters?: Array<ApiParameter>;
        integrationDetails: {
          connectionName: string;
        };
      }
    | {
        name: string;
        type: "Google";
        iconUrl?: string | null;
        baseUrl: string;
        description?: string | null;
        authenticationDetails:
          | {
              authenticationType: "Basic";
              authenticationDetails: {
                userName: string;
                password: string;
              };
            }
          | {
              authenticationType: "APIKey";
              authenticationDetails: {
                apiKey: string;
                apiKeyName: string;
                mappingType: "Header" | "QueryParameter";
              };
            }
          | {
              authenticationType: "None";
            };
        apiParameters?: Array<ApiParameter>;
        integrationDetails: {
          clientEmail: string;
          privateKey: string;
          privateKeyId: string;
          delegatedAdminEmail: string;
        };
      }
    | {
        name: string;
        type: "LocalTransform";
        iconUrl?: string | null;
        baseUrl: string;
        description?: string | null;
        authenticationDetails:
          | {
              authenticationType: "Basic";
              authenticationDetails: {
                userName: string;
                password: string;
              };
            }
          | {
              authenticationType: "APIKey";
              authenticationDetails: {
                apiKey: string;
                apiKeyName: string;
                mappingType: "Header" | "QueryParameter";
              };
            }
          | {
              authenticationType: "None";
            };
        apiParameters?: Array<ApiParameter>;
      };
  path: {
    id: string;
  };
  query?: never;
  url: "/integrations/{id}";
};

export type UpdateIntegrationErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateIntegrationError =
  UpdateIntegrationErrors[keyof UpdateIntegrationErrors];

export type UpdateIntegrationResponses = {
  /**
   * UpdateIntegrationsResponse
   *
   * Default Response
   */
  200: Integration;
};

export type UpdateIntegrationResponse =
  UpdateIntegrationResponses[keyof UpdateIntegrationResponses];

export type ListUsersData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
  };
  url: "/users";
};

export type ListUsersResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<User>;
  };
};

export type ListUsersResponse = ListUsersResponses[keyof ListUsersResponses];

export type CreateUserData = {
  body: {
    fullName: string;
    email: string;
    status: "Active" | "Pending" | "Disabled";
  };
  path?: never;
  query?: never;
  url: "/users";
};

export type CreateUserErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateUserError = CreateUserErrors[keyof CreateUserErrors];

export type CreateUserResponses = {
  /**
   * Default Response
   */
  201: User;
};

export type CreateUserResponse = CreateUserResponses[keyof CreateUserResponses];

export type DeleteUserData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/users/{id}";
};

export type DeleteUserErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteUserError = DeleteUserErrors[keyof DeleteUserErrors];

export type DeleteUserResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteUserResponse = DeleteUserResponses[keyof DeleteUserResponses];

export type UpdateUserData = {
  body: {
    fullName: string;
    email: string;
    status: "Active" | "Pending" | "Disabled";
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/users/{id}";
};

export type UpdateUserErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateUserError = UpdateUserErrors[keyof UpdateUserErrors];

export type UpdateUserResponses = {
  /**
   * Default Response
   */
  200: User;
};

export type UpdateUserResponse = UpdateUserResponses[keyof UpdateUserResponses];

export type ListPollersData = {
  body?: never;
  path?: never;
  query?: {
    cursor?: string;
    pageSize?: PageSizeParam;
  };
  url: "/pollers";
};

export type ListPollersResponses = {
  /**
   * Default Response
   */
  200: {
    nextCursor: string | null;
    hasMore: boolean;
    items: Array<Poller>;
  };
};

export type ListPollersResponse =
  ListPollersResponses[keyof ListPollersResponses];

export type CreatePollerData = {
  body: {
    name: string;
    queryActionId: string;
    alertSourceId: string;
    inputMappings?: Array<InputParameter>;
  };
  path?: never;
  query?: never;
  url: "/pollers";
};

export type CreatePollerErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreatePollerError = CreatePollerErrors[keyof CreatePollerErrors];

export type CreatePollerResponses = {
  /**
   * Default Response
   */
  201: Poller;
};

export type CreatePollerResponse =
  CreatePollerResponses[keyof CreatePollerResponses];

export type DeletePollerData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/pollers/{id}";
};

export type DeletePollerErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeletePollerError = DeletePollerErrors[keyof DeletePollerErrors];

export type DeletePollerResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeletePollerResponse =
  DeletePollerResponses[keyof DeletePollerResponses];

export type GetPollerData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/pollers/{id}";
};

export type GetPollerErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetPollerError = GetPollerErrors[keyof GetPollerErrors];

export type GetPollerResponses = {
  /**
   * Default Response
   */
  200: Poller;
};

export type GetPollerResponse = GetPollerResponses[keyof GetPollerResponses];

export type UpdatePollerData = {
  body?: {
    name?: string;
    queryActionId?: string;
    alertSourceId?: string;
    inputMappings?: Array<InputParameter>;
  };
  path: {
    id: string;
  };
  query?: never;
  url: "/pollers/{id}";
};

export type UpdatePollerErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdatePollerError = UpdatePollerErrors[keyof UpdatePollerErrors];

export type UpdatePollerResponses = {
  /**
   * Default Response
   */
  200: Poller;
};

export type UpdatePollerResponse =
  UpdatePollerResponses[keyof UpdatePollerResponses];

export type SearchPollersData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Generic search term
     */
    searchTerm: string;
  };
  url: "/pollers/search";
};

export type SearchPollersErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SearchPollersError = SearchPollersErrors[keyof SearchPollersErrors];

export type SearchPollersResponses = {
  /**
   * Default Response
   */
  200: Array<Poller>;
};

export type SearchPollersResponse =
  SearchPollersResponses[keyof SearchPollersResponses];

export type ExecuteSavedQueryActionData = {
  body: {
    inputMappings: Array<InputParameter>;
  };
  path: {
    queryActionId: string;
  };
  query?: never;
  url: "/query-actions/{queryActionId}/execute";
};

export type ExecuteSavedQueryActionErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ExecuteSavedQueryActionError =
  ExecuteSavedQueryActionErrors[keyof ExecuteSavedQueryActionErrors];

export type ExecuteSavedQueryActionResponses = {
  /**
   * Default Response
   */
  201: {
    statusCode: number;
    rawResponse: string;
    isError: boolean;
    message: string;
    outputEntities?: Array<{
      id: string;
      /**
       * The entity ID of the entity type, corresponding to qualified name
       */
      entityId: string;
      relationship: string;
      value: string;
      qualifiedName: string;
      parentId?: string | null;
    }>;
  };
};

export type ExecuteSavedQueryActionResponse =
  ExecuteSavedQueryActionResponses[keyof ExecuteSavedQueryActionResponses];

export type TestQueryActionData = {
  body: {
    name: string;
    method: "GET" | "POST" | "PUT" | "DELETE";
    url: string;
    description?: string | null;
    integrationId: string;
    requestPayload?: string | null;
    agenticSettingsId?: string | null;
    apiParameters?: Array<ApiParameter>;
    outputMappings: Array<{
      qualifiedName: string;
      relationship: string;
      liquidTemplate: string;
      outputType: "STRING" | "LIST";
      isRoot?: boolean | null;
    }>;
    inputEntities?: Array<{
      entityId: string;
    }>;
    inputMappings: Array<InputParameter>;
  };
  path?: never;
  query?: never;
  url: "/query-actions/test";
};

export type TestQueryActionErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type TestQueryActionError =
  TestQueryActionErrors[keyof TestQueryActionErrors];

export type TestQueryActionResponses = {
  /**
   * Default Response
   */
  201: {
    statusCode: number;
    rawResponse: string;
    isError: boolean;
    message: string;
    outputEntities?: Array<{
      id: string;
      /**
       * The entity ID of the entity type, corresponding to qualified name
       */
      entityId: string;
      relationship: string;
      value: string;
      qualifiedName: string;
      parentId?: string | null;
    }>;
  };
};

export type TestQueryActionResponse =
  TestQueryActionResponses[keyof TestQueryActionResponses];

export type ListQueryActionData = {
  body?: never;
  path?: never;
  query?: {
    currentPage?: PageParam;
    pageSize?: PageSizeParam;
    integrationId?: string;
  };
  url: "/query-actions";
};

export type ListQueryActionErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ListQueryActionError =
  ListQueryActionErrors[keyof ListQueryActionErrors];

export type ListQueryActionResponses = {
  /**
   * Default Response
   */
  200: PaginatedResponse & {
    items: Array<QueryAction>;
  };
};

export type ListQueryActionResponse =
  ListQueryActionResponses[keyof ListQueryActionResponses];

export type CreateQueryActionData = {
  body: {
    name: string;
    method: "GET" | "POST" | "PUT" | "DELETE";
    url: string;
    description?: string | null;
    integrationId: string;
    requestPayload?: string | null;
    agenticSettingsId?: string | null;
    apiParameters?: Array<ApiParameter>;
    outputMappings: Array<{
      qualifiedName: string;
      relationship: string;
      liquidTemplate: string;
      outputType: "STRING" | "LIST";
      isRoot?: boolean | null;
    }>;
    inputEntities?: Array<{
      entityId: string;
    }>;
    defaultAgenticSettings?: {
      confidenceLevel: "low" | "medium" | "high";
      costWeight: number;
      maxRetries: number;
      preconditions: string;
      timeoutSeconds: number;
    };
  };
  path?: never;
  query?: never;
  url: "/query-actions";
};

export type CreateQueryActionErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateQueryActionError =
  CreateQueryActionErrors[keyof CreateQueryActionErrors];

export type CreateQueryActionResponses = {
  /**
   * CreateQueryActionResponse
   *
   * Default Response
   */
  201: QueryAction;
};

export type CreateQueryActionResponse =
  CreateQueryActionResponses[keyof CreateQueryActionResponses];

export type DeleteQueryActionData = {
  body?: never;
  path: {
    queryActionId: string;
  };
  query?: never;
  url: "/query-actions/{queryActionId}";
};

export type DeleteQueryActionErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type DeleteQueryActionError =
  DeleteQueryActionErrors[keyof DeleteQueryActionErrors];

export type DeleteQueryActionResponses = {
  /**
   * Default Response
   */
  204: {
    message: string;
  };
};

export type DeleteQueryActionResponse =
  DeleteQueryActionResponses[keyof DeleteQueryActionResponses];

export type GetQueryActionData = {
  body?: never;
  path: {
    queryActionId: string;
  };
  query?: never;
  url: "/query-actions/{queryActionId}";
};

export type GetQueryActionErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetQueryActionError =
  GetQueryActionErrors[keyof GetQueryActionErrors];

export type GetQueryActionResponses = {
  /**
   * Default Response
   */
  200: QueryAction;
};

export type GetQueryActionResponse =
  GetQueryActionResponses[keyof GetQueryActionResponses];

export type UpdateQueryActionData = {
  body: {
    name: string;
    method: "GET" | "POST" | "PUT" | "DELETE";
    url: string;
    description?: string | null;
    integrationId: string;
    requestPayload?: string | null;
    agenticSettingsId?: string | null;
    apiParameters?: Array<ApiParameter>;
    outputMappings: Array<{
      qualifiedName: string;
      relationship: string;
      liquidTemplate: string;
      outputType: "STRING" | "LIST";
      isRoot?: boolean | null;
    }>;
    inputEntities?: Array<{
      entityId: string;
    }>;
    defaultAgenticSettings?: {
      confidenceLevel: "low" | "medium" | "high";
      costWeight: number;
      maxRetries: number;
      preconditions: string;
      timeoutSeconds: number;
    };
  };
  path: {
    queryActionId: string;
  };
  query?: never;
  url: "/query-actions/{queryActionId}";
};

export type UpdateQueryActionErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type UpdateQueryActionError =
  UpdateQueryActionErrors[keyof UpdateQueryActionErrors];

export type UpdateQueryActionResponses = {
  /**
   * UpdateQueryActionResponse
   *
   * Default Response
   */
  200: QueryAction;
};

export type UpdateQueryActionResponse =
  UpdateQueryActionResponses[keyof UpdateQueryActionResponses];

export type SearchQueryActionsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Search term to match against query action name, description, and integration details
     */
    searchTerm: string;
  };
  url: "/query-actions/search";
};

export type SearchQueryActionsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SearchQueryActionsError =
  SearchQueryActionsErrors[keyof SearchQueryActionsErrors];

export type SearchQueryActionsResponses = {
  /**
   * Default Response
   */
  200: Array<QueryAction>;
};

export type SearchQueryActionsResponse =
  SearchQueryActionsResponses[keyof SearchQueryActionsResponses];

export type QueryActionsForNodeData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/query-actions-for/{id}";
};

export type QueryActionsForNodeErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type QueryActionsForNodeError =
  QueryActionsForNodeErrors[keyof QueryActionsForNodeErrors];

export type QueryActionsForNodeResponses = {
  /**
   * Default Response
   */
  200: Array<QueryActionForNode>;
};

export type QueryActionsForNodeResponse =
  QueryActionsForNodeResponses[keyof QueryActionsForNodeResponses];

export type ReceiveWebhookData = {
  body?: {
    [key: string]: unknown;
  };
  path: {
    /**
     * The webhook ID to identify the alert source
     */
    webhookId: string;
  };
  query?: never;
  url: "/webhook/{webhookId}";
};

export type ReceiveWebhookErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ReceiveWebhookError =
  ReceiveWebhookErrors[keyof ReceiveWebhookErrors];

export type ReceiveWebhookResponses = {
  /**
   * Default Response
   */
  200: {
    workflowId: string;
    /**
     * The workspace (graph) ID to identify the created workspace
     */
    graphId: string;
  };
};

export type ReceiveWebhookResponse =
  ReceiveWebhookResponses[keyof ReceiveWebhookResponses];

export type TriggerAgentData = {
  body: {
    /**
     * The prompt to guide the agentic workflow
     */
    prompt: string;
    /**
     * The webhook payload data
     */
    data?: {
      [key: string]: unknown;
    };
  };
  path: {
    /**
     * The webhook ID to identify the alert source
     */
    webhookId: string;
  };
  query?: never;
  url: "/webhook/trigger/{webhookId}";
};

export type TriggerAgentErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type TriggerAgentError = TriggerAgentErrors[keyof TriggerAgentErrors];

export type TriggerAgentResponses = {
  /**
   * Default Response
   */
  200: {
    workflowId: string;
    /**
     * The workspace (graph) ID to identify the created workspace
     */
    graphId: string;
  };
};

export type TriggerAgentResponse =
  TriggerAgentResponses[keyof TriggerAgentResponses];

export type GetWorkflowsData = {
  body?: never;
  path?: never;
  query?: {
    graphId?: string;
    workflowIds?: string;
    sortDirection?: SortDirection;
  };
  url: "/workflows";
};

export type GetWorkflowsErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetWorkflowsError = GetWorkflowsErrors[keyof GetWorkflowsErrors];

export type GetWorkflowsResponses = {
  /**
   * Default Response
   */
  200: Array<Workflow>;
};

export type GetWorkflowsResponse =
  GetWorkflowsResponses[keyof GetWorkflowsResponses];

export type CreateWorkflowOrLocalActionData = {
  body: {
    /**
     * Graph ID
     */
    graphId: string;
    /**
     * Node ID
     */
    nodeId: string;
    /**
     * Query action with runtime values
     */
    queryAction: {
      /**
       * Query Action ID
       */
      id: string;
      /**
       * Query Action input parameters
       */
      inputParameters: Array<InputParameter>;
      /**
       * Selected output mapping IDs (relationship IDs) to execute
       */
      selectedOutputMappingIds: Array<string>;
    };
  };
  path?: never;
  query?: never;
  url: "/workflows";
};

export type CreateWorkflowOrLocalActionResponses = {
  /**
   * Default Response
   */
  200: GraphDetails;
  /**
   * Default Response
   */
  201: {
    /**
     * ID of the created workflow
     */
    id: string;
  };
};

export type CreateWorkflowOrLocalActionResponse =
  CreateWorkflowOrLocalActionResponses[keyof CreateWorkflowOrLocalActionResponses];

export type GetWorkflowData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/workflows/{id}";
};

export type GetWorkflowErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetWorkflowError = GetWorkflowErrors[keyof GetWorkflowErrors];

export type GetWorkflowResponses = {
  /**
   * Default Response
   */
  200: Workflow;
};

export type GetWorkflowResponse =
  GetWorkflowResponses[keyof GetWorkflowResponses];

export type GetWorkflowsStreamData = {
  body?: never;
  path: {
    graphId: string;
  };
  query?: never;
  url: "/workflows/{graphId}/stream";
};

export type GetWorkflowsStreamErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetWorkflowsStreamError =
  GetWorkflowsStreamErrors[keyof GetWorkflowsStreamErrors];

export type GetWorkflowsStreamResponses = {
  /**
   * Server-Sent Events stream
   */
  200: SseEvent;
};

export type GetWorkflowsStreamResponse =
  GetWorkflowsStreamResponses[keyof GetWorkflowsStreamResponses];

export type GetWorkflowRawDataData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/workflows/{id}/raw";
};

export type GetWorkflowRawDataErrors = {
  /**
   * Bad Request
   */
  400: ValidationError;
  /**
   * Not Found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetWorkflowRawDataError =
  GetWorkflowRawDataErrors[keyof GetWorkflowRawDataErrors];

export type GetWorkflowRawDataResponses = {
  /**
   * Default Response
   */
  200: {
    [key: string]: unknown;
  };
};

export type GetWorkflowRawDataResponse =
  GetWorkflowRawDataResponses[keyof GetWorkflowRawDataResponses];
